import { Field, Form as FormFormik, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  changePasswordInApp,
  getCollabById /* , editProfile */
} from 'redux/colabsSlice';
import MyButtonSpinner from 'components/common/my-components/MyButtonSpinner';
import { userUpdatePasswordSchema } from '../validations/userUpdatePasswordSchema';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const UserUpdatePasswordForm = ({ user }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    actualPassword: false,
    newPassword: false,
    confirmPassword: false
  });

  const handleSubmit = async values => {
    setIsLoading(true);

    let userData = {
      actualPassword: values.actualPassword,
      newPassword: values.newPassword
    };

    const response = await dispatch(changePasswordInApp(user.id, userData));
    //editProfile //para el collab
    if (response?.status < 400) {
      dispatch(getCollabById(user.id));
    }

    setIsLoading(false);
  };

  const handleViewPassword = field => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !showPassword[field]
    }));
  };

  return (
    <Formik
      initialValues={{
        actualPassword: '',
        newPassword: '',
        confirmPassword: ''
      }}
      validationSchema={userUpdatePasswordSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched }) => {
        return (
          <FormFormik>
            <Row className="g-3">
              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>Contraseña Actual</small>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    as={Field}
                    isInvalid={errors.actualPassword && touched.actualPassword}
                    name="actualPassword"
                    type={showPassword.actualPassword ? 'text' : 'password'}
                    placeholder="Contraseña Actual"
                  />

                  <InputGroup.Text
                    className="px-2"
                    onClick={() => handleViewPassword('actualPassword')}
                    style={{
                      width: '13%',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <FontAwesomeIcon
                      icon={showPassword.password ? 'eye-slash' : 'eye'}
                      style={{ cursor: 'pointer' }}
                    />
                  </InputGroup.Text>
                </InputGroup>

                {errors.actualPassword && touched.actualPassword ? (
                  <p className="text-danger small m-0">
                    {errors.actualPassword}
                  </p>
                ) : null}
              </Col>

              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>Nueva Contraseña</small>
                </Form.Label>

                <InputGroup>
                  <Form.Control
                    as={Field}
                    isInvalid={errors.newPassword && touched.newPassword}
                    name="newPassword"
                    type={showPassword.newPassword ? 'text' : 'password'}
                    placeholder="Nueva Contraseña"
                  />

                  <InputGroup.Text
                    className="px-2"
                    onClick={() => handleViewPassword('newPassword')}
                    style={{
                      width: '13%',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <FontAwesomeIcon
                      icon={showPassword.newPassword ? 'eye-slash' : 'eye'}
                      style={{ cursor: 'pointer' }}
                    />
                  </InputGroup.Text>
                </InputGroup>

                {errors.newPassword && touched.newPassword ? (
                  <p className="text-danger small m-0">{errors.newPassword}</p>
                ) : null}
              </Col>

              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>Confirmar Contraseña</small>
                </Form.Label>

                <InputGroup>
                  <Form.Control
                    as={Field}
                    isInvalid={
                      errors.confirmPassword && touched.confirmPassword
                    }
                    name="confirmPassword"
                    type={showPassword.confirmPassword ? 'text' : 'password'}
                    placeholder="Confirmar Contraseña"
                  />

                  <InputGroup.Text
                    className="px-2"
                    onClick={() => handleViewPassword('confirmPassword')}
                    style={{
                      width: '13%',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <FontAwesomeIcon
                      icon={showPassword.confirmPassword ? 'eye-slash' : 'eye'}
                      style={{ cursor: 'pointer' }}
                    />
                  </InputGroup.Text>
                </InputGroup>

                {errors.confirmPassword && touched.confirmPassword ? (
                  <p className="text-danger small m-0">
                    {errors.confirmPassword}
                  </p>
                ) : null}
              </Col>

              <Col xs={12}>
                {!isLoading ? (
                  <Button
                    variant="success"
                    type={
                      Object.keys(errors).length || isLoading
                        ? 'button'
                        : 'submit'
                    }
                    className="w-100"
                    disabled={Object.keys(errors).length || isLoading}
                  >
                    <FontAwesomeIcon
                      icon="fa-check"
                      style={{ marginRight: '5px' }}
                    />
                    Actualizar Contraseña
                  </Button>
                ) : (
                  <MyButtonSpinner className="w-100" />
                )}
              </Col>
            </Row>
          </FormFormik>
        );
      }}
    </Formik>
  );
};

UserUpdatePasswordForm.propTypes = {
  user: PropTypes.object
};
